import { render, staticRenderFns } from "./ChartRadar.vue?vue&type=template&id=72a050da&scoped=true"
import script from "./ChartRadar.vue?vue&type=script&lang=js"
export * from "./ChartRadar.vue?vue&type=script&lang=js"
import style0 from "./ChartRadar.vue?vue&type=style&index=0&id=72a050da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a050da",
  null
  
)

export default component.exports